// src/contexts/useToken.ts
import { useContext } from "react";
import { TokenContext, type TokenContextValue } from "./tokenContextDef";

/**
 * Hook to access token data from context.
 * Must be used within a TokenProvider.
 * 
 * @example
 * const { ticker, displayPrice, changesByWindow } = useToken();
 */
export const useToken = (): TokenContextValue => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error("useToken must be used within a TokenProvider");
  }
  return context;
};
